import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { NotFound } from "@/components/emptyPlaceholders/NotFound/NotFound";
import { useGetReviewsTreeQuery } from "@/stores/redux/api/reviewsApi";
import { reviewsStore } from "@/stores/ReviewsStore";
import { Review } from "@/types/Reviews";
import { IconStar } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Reply } from "../Reply/Reply";
import { ReviewItem } from "./ReviewItem";
import styles from "./Reviews.module.css";

export const ReviewList = observer(() => {
  const [viewLength, setViewLength] = useState(10);

  const { data } = useGetReviewsTreeQuery(
    { entityType: reviewsStore.entity_type, entityId: reviewsStore.entity_id },
    {
      pollingInterval: 60000,
    },
  );
  const reviews: Review[] = data?.reviews ?? [];

  return reviews.length > 0 ? (
    <div className={styles.reviews}>
      <div className="absolute -top-[100px] opacity-0 penter-events-none" id="replyForm" />
      <div className="flex flex-col !mt-3 relative">
        {reviewsStore.parent_id !== null && (
          <div
            className="
                    !relative
                    w-full md:w-[500px]
                    !my-5 
                    !p-2 
                    rounded-inherit 
                    
                    bg-[var(--global-bg-color))] 
                    border-1 
                    border-[rgba(0,0,0,0.55)] 
                    rounded 
                    before:content-[''] 
                    before:absolute 
                    before:top-0 
                    before:left-0 
                    before:w-full 
                    before:h-full
                    before:z-1
                    before:pointer-events-none
                    before:bg-[rgba(255,255,255,0.03)]
                 "
          >
            <Reply />
          </div>
        )}

        {reviews.map((review, i) => {
          if (i < viewLength + 1) {
            return <ReviewItem key={i} review={review} />;
          }
        })}

        {reviews.length > viewLength + 1 && (
          <div className="flex justify-center md:justify-start !my-3">
            <SaveButton className="!p-[12px] rounded-md" onClick={() => setViewLength(viewLength + 10)}>
              Показать еще
            </SaveButton>
          </div>
        )}
      </div>
    </div>
  ) : (
    <NotFound title="Отзывов пока нет" icon={<IconStar />} />
  );
});
